import Portal from "@common/controls/Portal/component";
import { Common } from "@common/types";
import classnames from "classnames";
import * as React from "react";
import { type TooltipLocation } from "../lib";

import "./style.less";

export type TooltipType = "black" | "orange" | "red";
export interface BaseTooltipProps {
  className?: string;
  delay?: number;
  location: TooltipLocation;
  pointerPosition: Common.LeftTop;
  ref?: React.RefObject<HTMLDivElement | null>;
  tooltip: any;
  type: TooltipType;
}

const BaseTooltip = (props: BaseTooltipProps) => {
  return (
    <Portal>
      <div
        className={classnames("tooltip", props.type, props.className, props.location.position, {
          delayed: !!props.delay
        })}
        ref={props.ref}
        style={
          {
            left: props.location.left,
            top: props.location.top,
            "--pointer-left": `${props.pointerPosition.left}px`,
            "--pointer-top": `${props.pointerPosition.top}px`,
            "--delay": props.delay ? `${props.delay}ms` : undefined
          } as any
        }
      >
        {typeof props.tooltip === "string" ? (
          <div dangerouslySetInnerHTML={{ __html: props.tooltip }} />
        ) : props.tooltip instanceof Function ? (
          props.tooltip()
        ) : (
          props.tooltip
        )}
      </div>
    </Portal>
  );
};

export default BaseTooltip;
